/**
 * List all possible events we track
 */
export enum CommunicationSessionEventLogName {
  conference = 'conference',
  dialPhone = 'dialPhone',
  sendMessage = 'sendMessage',
}
